import React, { CSSProperties } from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import Loader from '../loader';
import { Button, Dialog } from '../prime';

export interface IQuestionProps {
    storage?: IDataStorage;

    dialogClassname?: string;
    dialogStyle?: CSSProperties;

    visible?: boolean;
    title?: string;
    text?: string;
    data?: any;

    ok_text?: string;
    ok_class?: string;
    ok_style?: CSSProperties;
    cancel_text?: string;
    working?: boolean;

    ok?: (data?: any) => void;
    onClose?: () => void;
}

interface IState {
    storage?: IDataStorage;
  
    dialogClassname?: string;
    dialogStyle?: CSSProperties;

    visible?: boolean;
    title?: string;
    text?: string;
    data?: any;

    ok_text?: string;
    ok_class?: string;
    ok_style?: CSSProperties;
    cancel_text?: string;
    working?: boolean;
}

class Index extends React.Component<IQuestionProps, IState> {
    componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
    static getDerivedStateFromProps = (p: IQuestionProps, s?: IState) : IState => {
        let res : IState = { };
        if (p?.storage !== s?.storage) res.storage = p.storage;
        if (p?.dialogClassname !== s?.dialogClassname) res.dialogClassname = p.dialogClassname;
        if (p?.dialogStyle !== s?.dialogStyle) res.dialogStyle = p.dialogStyle;

        if (p?.visible !== s?.visible) res.visible = p.visible;
        if (p?.title !== s?.title) res.title = p.title;
        if (p?.text !== s?.text) res.text = p.text;
        if (p?.data !== s?.data) res.data = p.data;

        if (p?.ok_text !== s?.ok_text) res.ok_text = p.ok_text;
        if (p?.ok_class !== s?.ok_class) res.ok_class = p.ok_class;
        if (p?.ok_style !== s?.ok_style) res.ok_style = p.ok_style;
        if (p?.cancel_text !== s?.cancel_text) res.cancel_text = p.cancel_text;
        if (p?.working !== s?.working) res.working = p.working;
        return res;
    }

    render() {
        const { visible, title, text, ok_text, cancel_text, ok_class, ok_style, working } = this.state;
        return (
            <Dialog 
                modal
                className={this.state.dialogClassname}
                style={this.state.dialogStyle}
                dismissableMask
                visible={!!visible} 
                onHide={() => this.props.onClose && this.props.onClose()}
                header={title}
                footer={
                    <div style={{ fontSize: '.8em' }}>
                        <Button label={cancel_text} className="p-button-secondary" onClick={() => this.props.onClose && this.props.onClose()}/>
                        <Loader loading={working} style={{display: 'inline-block'}} >
                            <Button label={ok_text} className={ok_class} style={ok_style} onClick={() => this.props.ok && this.props.ok(this.state.data)} />
                        </Loader>
                    </div>
                }
            >
                <div dangerouslySetInnerHTML={{ __html: text ?? '' }} ></div>
            </Dialog>
        );
    }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
